import { useState, useEffect, useCallback } from "react";

import { api } from "@/lib/api";
import { contactGroups } from "@/lib/memberDerive";

// Confirmed contacts (accepted direct conversations) – the only people a member can name as recipient.
export function useConfirmedContacts() {
  const [state, setState] = useState({ list: null, error: false });
  const load = useCallback(() => {
    setState({ list: null, error: false });
    api.get("/member/conversations")
      .then((r) => setState({ list: contactGroups(r.data.conversations || []).accepted.map((c) => c.other || {}).filter((o) => o.id), error: false }))
      .catch(() => setState({ list: [], error: true }));
  }, []);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}

export function ContactSelect({ id, label, value, onChange, contacts, error }) {
  return (
    <label htmlFor={id} className="block">
      <span className="mb-1 block font-medium text-brand-purple">{label}</span>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} data-testid={id} aria-invalid={error ? "true" : undefined}
        className="h-12 w-full rounded-xl border border-brand-purple/25 bg-white px-3 text-base text-brand-purple focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-magenta">
        <option value="">{contacts === null ? "Kontakte werden geladen …" : contacts.length ? "Bitte auswählen" : "Noch keine bestätigten Kontakte"}</option>
        {(contacts || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      {error && <span role="alert" className="mt-1 block text-sm font-medium text-red-800" data-testid={`${id}-error`}>{error}</span>}
    </label>
  );
}
